import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import fetchMiddleware from '../components/Fetch/middleware';
import rootReducer from '../reducers';

const middlewares = [thunk, fetchMiddleware];

const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore);
const store = createStoreWithMiddleware(
  rootReducer,
  // eslint-disable-next-line no-underscore-dangle
  (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__) && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
